import React, { useEffect } from 'react';
import { Drawer, Form, Input, Button, message } from 'antd';
import * as actions from "store/actions/AuthActions";
import useIsMobile from 'hooks/useIsMobile';

const { TextArea } = Input;

const DealCompetitorForm = ({ visible, onClose, dealId, instance, onSuccess }) => {
    const [form] = Form.useForm();
    const isMobile = useIsMobile();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (visible && instance) {
            form.setFieldsValue({
                competitor_name: instance.competitor_name,
                website: instance.website,
                strengths: instance.strengths,
                weaknesses: instance.weaknesses,
            });
        } else if (visible && !instance) {
            form.resetFields();
        }
    }, [visible, instance]);

    const handleSubmit = async (values) => {
        try {
            const data = {
                ...values,
                deal: dealId,
            };

            // Remove empty website field to avoid validation errors
            if (!data.website || data.website.trim() === '') {
                delete data.website;
            }

            if (instance) {
                await actions.updateDealCompetitor(data, instance.id);
                message.success('Competitor updated successfully');
            } else {
                await actions.addDealCompetitor(data);
                message.success('Competitor added successfully');
            }

            form.resetFields();
            onSuccess();
        } catch (error) {
            console.error('Competitor Error:', error);
            console.error('Error Response:', error.response?.data);
            const errorMsg = error.response?.data?.detail || error.response?.data?.error || JSON.stringify(error.response?.data) || 'Failed to save competitor';
            message.error(errorMsg);
        }
    };

    return (
        <Drawer
            title={`${instance ? 'Edit' : 'Add'} Competitor`}
            placement={isMobile ? "bottom" : "right"}
            width={isMobile ? "100%" : 500}
            height={isMobile ? "90vh" : undefined}
            onClose={onClose}
            open={visible}
            styles={{
                body: { paddingBottom: isMobile ? 80 : 24 }
            }}
            footer={
                <div style={{ display: 'flex', justifyContent: isMobile ? 'stretch' : 'flex-end', gap: '8px' }}>
                    <Button onClick={onClose} style={isMobile ? { flex: 1 } : undefined}>Cancel</Button>
                    <Button type="primary" onClick={() => form.submit()} style={isMobile ? { flex: 1 } : undefined}>
                        {instance ? 'Update' : 'Add'}
                    </Button>
                </div>
            }
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
            >
                <Form.Item
                    label="Competitor Name"
                    name="competitor_name"
                    rules={[{ required: true, message: 'Please enter competitor name!' }]}
                >
                    <Input placeholder="Enter competitor name" />
                </Form.Item>

                <Form.Item
                    label="Website"
                    name="website"
                >
                    <Input placeholder="https://example.com" />
                </Form.Item>

                <Form.Item
                    label="Strengths"
                    name="strengths"
                >
                    <TextArea rows={4} placeholder="What are their strengths?" />
                </Form.Item>

                <Form.Item
                    label="Weaknesses"
                    name="weaknesses"
                >
                    <TextArea rows={4} placeholder="What are their weaknesses?" />
                </Form.Item>
            </Form>
        </Drawer>
    );
};

export default DealCompetitorForm;
